import { useMutation } from '@tanstack/react-query'
import { RelatoriosApi } from '@/services/api-routes'
import type { GerarRelatorioFiltro } from '@/types/relatorio'
import { notifyErrorFor, notifySuccess } from '@/utility/notify'
import { base64ParaBlob, downloadBlob } from '@/utility/Utils'

export const useGerarRelatorioMutation = () =>
  useMutation({
    mutationFn: ({ clienteId, filtro }: { clienteId: string; filtro: GerarRelatorioFiltro }) =>
      RelatoriosApi.download(clienteId, filtro),
    onSuccess: (arquivo) => {
      if (!arquivo) {
        notifyErrorFor('gerar o relatório')
        return
      }

      downloadBlob(base64ParaBlob(arquivo.base64), arquivo.nomeArquivo)
      notifySuccess('Relatório gerado com sucesso!')
    },
    onError: (error) => notifyErrorFor('gerar o relatório', error),
  })
